import { render, staticRenderFns } from "./ChangeButton.vue?vue&type=template&id=2f5631f2&"
import script from "./ChangeButton.vue?vue&type=script&lang=js&"
export * from "./ChangeButton.vue?vue&type=script&lang=js&"
import style0 from "./ChangeButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports